<div class="igntr-theme bg-[--background-color]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px] pb-12"
  >
    <app-page-hero
      [title]="'tenants'"
      [description]="
        allTenants.length +
        ' ' +
        ('workspaces' | transloco) +
        ' · ' +
        totalUsers +
        ' ' +
        ('usersTotal' | transloco)
      "
      showSearchBar
      showLayoutSwitch
      [newButton]="{ route: '/tenants/new', text: 'newTenant' }"
      (searchEmitter)="searchQuery = $event; applyFilter()"
      (layoutSwitchEmitter)="viewMode = $event"
    >
    </app-page-hero>

    <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
    <app-tenant-list
      *ngIf="!(repo.isLoading$ | async)"
      style="width: 100%"
      [innerWidth]="innerWidth"
      [viewMode]="viewMode"
      [tenants]="filteredTenants"
      [isDeleteDisabled]="
        !(auth.isSuperAdmin$ | async) && !(auth.isPartnerManager$ | async)
      "
      (delete)="delete($event)"
      (clone)="handleCloneClick($event); (refreshData)"
    ></app-tenant-list>

    <div
      class="flex items-center justify-between mt-6 text-[14px] !text-slate-500"
      *ngIf="allTenants.length >= 0"
    >
      <div class="font-mono tabular-nums">
        Showing {{ allTenants.length }} of {{ allTenants.length }}
      </div>
      <div class="flex items-center gap-1">
        <button class="px-2 py-1 rounded-md hover:bg-slate-100">‹</button
        ><span class="font-mono tabular-nums px-1">1 / 1</span
        ><button class="px-2 py-1 rounded-md hover:bg-slate-100">›</button>
      </div>
    </div>
  </div>
</div>

<p-button
  class="flex sm:hidden mobile-add-button"
  icon="pi pi-plus"
  [routerLink]="['/tenants/new']"
/>
